import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Update from './actions/update';
import Delete from './actions/delete';
import Resource from './resource';

export default class Membership extends Resource {
  get resourceName() {
    return 'membership';
  }

  get resourcesName() {
    return 'memberships';
  }

  async changePermissions(changes) {
    const options = {
      method: 'POST',
      path: this.collectionAction('change_permissions'),
      body: { change: changes },
    };

    const body = await this.call(options);

    if (body) {
      return JSON.parse(body)[this.resourceName];
    }

    return {};
  }
}
// @ts-ignore
List.includeInto(Membership);
// @ts-ignore
Find.includeInto(Membership);
// @ts-ignore
Create.includeInto(Membership);
// @ts-ignore
Update.includeInto(Membership);
// @ts-ignore
Delete.includeInto(Membership);
